import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import * as CartKeys from '../reactQueryKeys/cart'
import { NON_TRIP_STALE_TIME } from './common'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import type { CartItemResponse } from 'api/cart/getCartItems'
import { getCartItems } from 'api/cart/getCartItems'

export const useCart = (
  cartId: string | undefined,
): UseQueryResult<CartItemResponse | undefined, unknown> => {
  return useQuery({
    queryKey: CartKeys.detail(cartId || ''),
    queryFn: () => cartId ? getCartItems(cartId) : Promise.resolve(undefined),
    staleTime: NON_TRIP_STALE_TIME,
  })
}

export const useCartHotelItems = (
  cartId: string | undefined,
): UseQueryResult<Array<App.Checkout.AccommodationItem>, unknown> => {
  const isLoggedIn = useAppSelector(selectLoggedIn)

  return useQuery({
    queryKey: [...CartKeys.hotelItems(cartId || ''), 'loggedIn', isLoggedIn],
    queryFn: async() => {
      if (!cartId) return []

      const cart = await getCartItems(cartId)
      return cart.items.filter(item =>
        item.itemType === 'hotel' || item.itemType === 'bedbankHotel',
      )
    },
    staleTime: NON_TRIP_STALE_TIME,
  })
}
